const defaultBookmarks = [
  // 常用工具
  {
    id: 1,
    title: '百度翻译',
    url: 'https://fanyi.baidu.com',
    description: '中英文在线翻译工具',
    category: 'tools',
    createdAt: new Date().toISOString()
  },
  {
    id: 2,
    title: 'GitHub',
    url: 'https://github.com',
    description: '全球最大的代码托管平台',
    category: 'tools',
    createdAt: new Date().toISOString()
  },

  // 社交媒体
  {
    id: 3,
    title: '知乎',
    url: 'https://www.zhihu.com',
    description: '中文问答社区',
    category: 'social',
    createdAt: new Date().toISOString()
  },
  {
    id: 4,
    title: '微博',
    url: 'https://weibo.com',
    description: '中国最大的社交媒体平台',
    category: 'social',
    createdAt: new Date().toISOString()
  },

  // 学习资源
  {
    id: 5,
    title: '掘金',
    url: 'https://juejin.cn',
    description: '优质的开发者社区',
    category: 'learning',
    createdAt: new Date().toISOString()
  },
  {
    id: 6,
    title: 'Stack Overflow',
    url: 'https://stackoverflow.com',
    description: '程序员问答社区',
    category: 'learning',
    createdAt: new Date().toISOString()
  },

  // 视频娱乐
  {
    id: 7,
    title: 'Bilibili',
    url: 'https://www.bilibili.com',
    description: '国内知名的视频弹幕网站',
    category: 'video',
    createdAt: new Date().toISOString()
  },
  {
    id: 8,
    title: '腾讯视频',
    url: 'https://v.qq.com',
    description: '在线视频网站',
    category: 'video',
    createdAt: new Date().toISOString()
  },

  // 购物网站
  {
    id: 9,
    title: '淘宝',
    url: 'https://www.taobao.com',
    description: '中国最大的购物网站',
    category: 'shopping',
    createdAt: new Date().toISOString()
  },
  {
    id: 10,
    title: '京东',
    url: 'https://www.jd.com',
    description: '综合网上购物平台',
    category: 'shopping',
    createdAt: new Date().toISOString()
  }
];

export default defaultBookmarks; 